import Link from 'next/link';

import type { ILinkSectionData } from '@/shared/actions/navigation.service';
import { SubsectionLink } from '@/shared/components/header/shared/subsection-link';
import { ImageImgix } from '@/shared/ui/media/image-imgix';

export interface IMenuOverlayProps {
    item: ILinkSectionData;
}

export function MenuOverlay({ item }: IMenuOverlayProps) {
    return (
        <div className='dropdown-auto-align bg-surface-white inline-flex w-160 shrink-0 items-start'>
            <div className='flex w-67 shrink-0 flex-col items-start gap-10 p-10 pr-0'>
                {item.title && <SubsectionLink url={item.internalLink || item.url || '#'} title={item.title} />}
                <div className='text-body-sm-400 flex w-max shrink-0 cursor-pointer flex-col items-start gap-4'>
                    {item.links?.map(link => (
                        <Link href={link.internalLink || link.url || '#'} key={`${link.id}`}>
                            {link.title}
                        </Link>
                    ))}
                </div>
            </div>
            <div className='bg-surface-white flex flex-col items-start gap-6 px-6 py-10'>
                {item.image && (
                    <div className='h-51 w-80'>
                        <ImageImgix
                            {...item.image}
                            sizes='100vw'
                            imgixSizes={{
                                max: {
                                    width: 321,
                                    height: 206,
                                },
                            }}
                        />
                    </div>
                )}
                {item.description && <p className='text-body-xs-400'>{item.description}</p>}
            </div>
        </div>
    );
}
